'use client';

import { c as _c } from "react/compiler-runtime";
import { type GetEventsRow, useGetEvents } from '@morfi/backend-sdk-v2/client';
import { useEffect } from 'react';
import { useLiveListData } from '@/hooks/sdk/use-live-list-data';
import { useLiveEventQueryDiagnostics } from './use-live-event-query-diagnostics';
export interface PublishedEventCatalog {
  query: ReturnType<typeof useGetEvents>;
  rows: readonly GetEventsRow[];
  isPending: boolean;
  isError: boolean;
  loadMore: () => void;
  retry: () => void;
}
export function usePublishedEventCatalog(enabled, loadAll) {
  const $ = _c(29);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      activeOnly: "false",
      limit: 100
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== enabled) {
    t1 = {
      enabled
    };
    $[1] = enabled;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const query = useGetEvents(t0, t1);
  const rows = useLiveListData(query.queryKey, query.rows, query.entityQueryKey, undefined, enabled);
  const {
    hasNextPage,
    isFetchingNextPage,
    isError,
    nextPageError,
    fetchNextPage
  } = query;
  const continuationFailed = nextPageError != null;
  let t2;
  if ($[3] !== rows) {
    t2 = {
      kind: "event_catalog",
      action: "event_feed",
      hasDisplayedResults: () => rows.length > 0
    };
    $[3] = rows;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const observeNextPage = useLiveEventQueryDiagnostics(query.queryKey, t2);
  let t3;
  let t4;
  if ($[5] !== continuationFailed || $[6] !== enabled || $[7] !== fetchNextPage || $[8] !== hasNextPage || $[9] !== isError || $[10] !== isFetchingNextPage || $[11] !== loadAll || $[12] !== observeNextPage) {
    t3 = () => {
      if (enabled && loadAll && hasNextPage && !isFetchingNextPage && !isError && !continuationFailed) {
        observeNextPage(fetchNextPage());
      }
    };
    t4 = [enabled, loadAll, hasNextPage, isFetchingNextPage, isError, continuationFailed, fetchNextPage, observeNextPage];
    $[5] = continuationFailed;
    $[6] = enabled;
    $[7] = fetchNextPage;
    $[8] = hasNextPage;
    $[9] = isError;
    $[10] = isFetchingNextPage;
    $[11] = loadAll;
    $[12] = observeNextPage;
    $[13] = t3;
    $[14] = t4;
  } else {
    t3 = $[13];
    t4 = $[14];
  }
  useEffect(t3, t4);
  const t5 = query.isPending || loadAll && hasNextPage && !isError && !continuationFailed;
  const t6 = isError || continuationFailed;
  let t7;
  if ($[15] !== observeNextPage || $[16] !== query) {
    t7 = () => observeNextPage(query.fetchNextPage());
    $[15] = observeNextPage;
    $[16] = query;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== continuationFailed || $[19] !== observeNextPage || $[20] !== query) {
    t8 = () => {
      if (continuationFailed) {
        observeNextPage(query.retryNextPage());
      } else {
        query.refetch();
      }
    };
    $[18] = continuationFailed;
    $[19] = observeNextPage;
    $[20] = query;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== query || $[23] !== rows || $[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8) {
    t9 = {
      query,
      rows,
      isPending: t5,
      isError: t6,
      loadMore: t7,
      retry: t8
    };
    $[22] = query;
    $[23] = rows;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
}